import { TokenManager } from '../../auth/TokenManager';
import { Button } from '../../cdl/Button/Button';
import { useCopyToClipboard } from '../../common/hooks/useCopyToClipboard';

export const CopyTokenButton = () => {
    const copyToClipboard = useCopyToClipboard();

    const onClick = async () => {
        const token = await TokenManager.getInstance().getToken();

        if (token) {
            copyToClipboard(token);
        }
    };

    return (
        <div>
            <Button onClick={onClick}>Copy token to clipboard</Button>
        </div>
    );
};
